export default function toZipCode(rawZipCode: number | string) {
  if (!rawZipCode) {
    return '';
  }
  const re = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/;
  const zipCodeString = rawZipCode.toString();
  const zipCode = zipCodeString?.replace(/\D/g, '');
  return zipCode?.slice(0, 8).replace(re, '$1$2-$3');
}
